import React, { useContext, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
// import Datepicker from 'react-datepicker';
import Select from "react-select";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Get, JENIS_DESA, JENIS_DUSUN, Post } from "../../function/Koneksi";
import { generateAlamat } from '../../function/Format';
import { Tanggal } from "../../function/Format";

const ModalSuratPindahWNI = ({
  data,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

    const frmDex = {
        uuid: '',
        id_jenis: '',
        nik_pelapor: '',
        nik: '',
        kk: '',
        nama_pemohon: '',
        tempat_lahir: '',
        tanggal_lahir: '',
        jenis_kelamin: '',
        pekerjaan: '',
        pendidikan_terakhir: '',
        kewarganegaraan: '',
        agama: '',
        alamat: '',
        alamat_kk: '',
        status_perkawinan: '',
        tujuan_pembuatan: '',

        telepon: '',
        kode_pos: '',

        // tambahan daerah asal
        no_kk: '',
        nama_kepala_keluarga: '',
        alamat_asal: '',
        rt_asal: '',
        rw_asal: '',
        provinsi_asal: '',
        kabkota_asal: '',
        kecamatan_asal: '',
        deskel_asal: '',
        kode_pos_asal: '',
        telp_asal: '',

        // dt pindah
        alasan_pindah: null,
        keterangan_alasan_pindah: '',
        alamat_pindah: '',
        rt_pindah: '',
        rw_pindah: '',
        kode_pos_pindah: '',
        telp_pindah: '',

        detail: [],
    };

	const initFormData = {
		frmKk: optionData.frmKk,
        frmNik: optionData.frmNik,
        frmShdk: optionData.frmShdk,
		kkStat: optionData.kkStat,
		nikStat: optionData.nikStat,
        nik2Stat: optionData.nik2Stat,
        shdk_aw: optionData.shdk_aw,
        isKelurahan: optionData.isKelurahan,
        // data pemohon
        dataPemohon: optionData.dataPemohon,
        detailKK: optionData.detailKK,
        kepalaKeluarga: optionData.kepalaKeluarga,
        // data kepindahan
        alasanPindah: optionData.alasanPindah,
        klasifikasiPindah: optionData.klasifikasiPindah,
        jenisPindah: optionData.jenisPindah,
        statusTidakPindah: optionData.statusTidakPindah,
        statusPindah: optionData.statusPindah,
        dtPindah: optionData.dtPindah,
        dtAsal: optionData.dtAsal,
        // wilayah
        frmPrv: optionData.frmPrv,
        frmKbkt: optionData.frmKbkt,
        frmKec: optionData.frmKec,
        frmKel: optionData.frmKel,
        prvStat: optionData.prvStat,
        kbktStat: optionData.kbktStat,
        kecStat: optionData.kecStat,
        kldsStat: optionData.kldsStat,

		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
            select: false,
			dataPelapor: "none",
			dataPenduduk: "none",
			frmPreviewDraft: false,
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
        // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

    const [formData, setFormData] = useState(initFormData);
    const [props, setProps] = useState(propsData);
    const [kioskMode, setKioskMode] = useState(kiosk)
    const [dt, setDt] = useState(data ? data : frmDex);

    useEffect(() => {
        if (document.getElementById("modalForm")) {
            document.getElementById("modalForm").reset();
        }

        setDt(data ? data : frmDex);
        setFormData(
        data
            ? {
                ...initFormData,
                kkStat: optionData.kkStat,
                nikStat: optionData.nikStat,
                nik2Stat: optionData.nik2Stat,
                shdk_aw: optionData.shdk_aw,
                alasanPindah: optionData.alasanPindah,
                klasifikasiPindah: optionData.klasifikasiPindah,
                jenisPindah: optionData.jenisPindah,
                statusTidakPindah: optionData.statusTidakPindah,
                statusPindah: optionData.statusPindah,
                frmPrv: optionData.frmPrv,
                frmKbkt: optionData.frmKbkt,
                frmKec: optionData.frmKec,
                frmKel: optionData.frmKel,
                prvStat: optionData.prvStat,
                kbktStat: optionData.kbktStat,
                kecStat: optionData.kecStat,
                kldsStat: optionData.kldsStat,
                status: optionData.status,
            }
            : initFormData
        );
    }, [isOpen]);

    const changeInputText = (e, type, input1, input2) => {
        if(type === "dt"){
            setDt({
                ...dt,
                [input1]: e.target.value
            });
        }
        else if(type === "formdata"){
            setFormData({
                ...formData,
                [input1]: {
                    ...formData[input1],
                    [input2]: e.target.value,
                }
            });
        }
    };

    const handleInputChangeNIK = (e, fld) => {
        if (e && kioskMode == false) {
            if (fld === 'kk') {
				let param = {
					id: e
				};
				Post('kartu-keluarga/select', null, param, (datakk) => {
					let frmKk = [];
					if (datakk.data.results.data.length > 0) {
						datakk.data.results.data.forEach((dt) => {
							frmKk.push({ value: dt.id, label: dt.nama_kepala_keluarga? dt.id + ' (' + dt.nama_kepala_keluarga.nama + ')' : dt.id });
						});

                        setFormData({
                            ...formData,
                            frmKk: frmKk,
                        })
					} 
                    // else {
					// 	Get('kartu-keluarga', null, (data) => {
					// 		data.results.data.forEach((dt) => {
                    //             frmKk.push({ value: dt.id, label: dt.nama_kepala_keluarga? dt.id + ' (' + dt.nama_kepala_keluarga.nama + ')' : dt.id });
					// 		});
					// 	});
					// }
				});
			}
            

            // // ==========
            // let nikStat = { value: e, label: e };

            // Post("penduduk", null, { nik: e }, datanik => {
            //     let frmNik = [];
            //     datanik.data.results.data.forEach(dt => {
            //     frmNik.push({ value: dt.id, label: dt.id + " (" + dt.nama + ")" });
            //     });

            //     switch (fld) {
            //     case "nik":
            //         setFormData({
            //         ...formData,
            //         frmNik,
            //         nikStat
            //         });
            //         break;
            //     case "meninggal":
            //         setFormData({
            //         ...formData,
            //         frmNik2: frmNik,
            //         nikStatMeninggal: nikStat
            //         });
            //         break;

            //     default:
            //         break;
            //     }
            // });
        }
    };

    const getPenduduk = (e, sel, jns) => {
        if (e) {

            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
            
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    if(jns === "pemohon"){
                        setFormData({
                            ...formData,
                            nikStat : {
                                value: e.value,
                                label: e.value
                            },
                            dataPemohon: {
                                nik: data.results.id,
                                nama_pemohon: data.results.nama,
                                tempat_lahir: data.results.tempat_lahir,
                                tanggal_lahir: data.results.tanggal_lahir,
                                pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                                pekerjaan: data.results.data_pekerjaan.nama,
                                agama: data.results.data_agama.nama,
                                status_perkawinan: data.results.status_perkawinan,
                                alamat: alamat,
                                alamat_kk: alamat_kk,
                                jenis_kelamin: data.results.jk,
                                kewarganegaraan: "WNI",
                                tujuan_pembuatan: 'Surat Keterangan Pindah Datang WNI',
                                kk: data.results.id_kk,
                            },
                        })
                    }

                            
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                        loadingPreview: false
                        })
                    }
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                        loadingPreview: false
                        })
                    }
                }
            });
        } else {
        switch (jns) {
            case "pelapor":
            setDt({
                ...dt,
                nama_meninggal:'',
                tempat_lahir_meninggal:'',
                tanggal_lahir_meninggal:'',
                waktu_meninggal: "",
                tempat_meninggal: "",
                sebab_meninggal: "",
                tempat_makam: "",
                tanggal_dimakamkan: "",
            })
            setFormData({
                ...formData,
                status: {
                ...formData.status,
                dataPelapor: "none",
                dataPenduduk:"none",
                },
                meninggal:"none",
                meninggal2:"none",
                nikStat: null,
                nikStatMeninggal: null,
            });
            break;
            case "meninggal":
            setDt({
                ...dt,
                waktu_meninggal: "",
                tempat_meninggal: "",
                sebab_meninggal: "",
                tempat_makam: "",
                tanggal_dimakamkan: "",
            });
            setFormData({
                ...formData,
                status: {
                ...formData.status,
                dataPenduduk: "none"
                },
                nikStatMeninggal: null,
            });
            break;
            default:
            break;
        }
        }
    };

    const getChild = (e, self, parent, child) => {
        let setValWilayah = changeSelectValue(e, self);
        let formDusun = formData.frmDus
    
        if (e) {
            if(formData.isKelurahan){
                Get(child + '/' + parent + '/' + e.value + '/list', null, (data) => {
                    let frm = [];
                    data.results.forEach((dt) => {
                        frm.push({ value: dt.id, label: dt.nama });
                    });

                    switch (child) {
                        case 'kab-kota':
                            setFormData({
                                ...formData,
                                frmKbkt: frm, 
                                frmKec: [] 
                            })
                            break;
                        case 'kecamatan':
                            setFormData({
                                ...formData,
                                frmKec: frm,
                            })
                            break;
                        case 'keldes':
                            setFormData({
                                ...formData,
                                frmKel: frm,
                            })
                            break;
                        case 'rw':
                            setFormData({
                                ...formData,
                                frmRw: frm,
                            })
                            break;
            
                        case 'rt':
                            setFormData({
                                ...formData,
                                frmRt: frm,
                            })
                            break;
                        default:
                        // no default
                        break;
                    }
                });
            }
            else{
                Get(child + '/' + parent + '/' + e.value + '/list', null, (data) => {
                    let frm = [];
                    data.results.forEach((dt) => {
                        frm.push({ value: dt.id, label: dt.nama });
                    });
                    
                    switch (child) {
                        // on change provinsi
                        case 'kab-kota':
                            setFormData({
                                ...formData,
                                frmKbkt: frm, 
                                frmKec: [],
                                frmKel: [],
                                prvStat: setValWilayah,
                                kbktStat: null,
                                kecStat: null,
                                kldsStat: null 
                            })
                            break;
                        // on change kabupaten
                        case 'kecamatan':
                            setFormData({
                                ...formData,
                                frmKec: frm, 
                                frmKel: [],
                                kbktStat: setValWilayah,
                                kecStat: null,
                                kldsStat: null 
                            })
                            break;
                        // on change kecamatan
                        case 'keldes':
                            setFormData({
                                ...formData,
                                frmKel: frm, 
                                kecStat: setValWilayah,
                                kldsStat: null 
                            })
                            break;
                        // on change kelurahan desa
                        case 'dusun':
                            // if (this.state.id_kategori_penduduk.value === 1) {
                                setFormData({
                                    ...formData,
                                    frmDus: frm, 
                                    kldsStat: setValWilayah,
                                })
                            // }
                            // else {
                            //     setFormData({
                            //         ...formData,
                            //         frmDus: formDusun 
                            //     })
                            // }
                            break;
            
                        case 'rw':
                            setFormData({
                                ...formData,
                                frmRw: frm, 
                            })
                            break;
            
                        case 'rt':
                            setFormData({
                                ...formData,
                                frmRt: frm, 
                            })
                            break;
                        default:
                        // no default
                        break;
                    }
                });
            }
        }
    };
    
    const changeSelectValue = (e, sel) => {
        if (e) {
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            switch (sel) {
                case 'kk':
                    setDt({
                        ...dt,
                        id_kk: e.value,
                    })

                    Get('kartu-keluarga/find', e.value, (data) => {
                        if (data.results) {
                            if(data.results.data_rt && data.results.data_rt.data_rw){
                                let kepalaKeluarga = ''
                                // #continuethis
                                // coba pke while break
                                data.results.data_keluarga.forEach((detail, index) => {
                                    if (detail.data_shdk.nama === 'Kepala Keluarga') {
                                        kepalaKeluarga = detail.nama
                                    } else if (index === data.results.data_keluarga.length - 1 && kepalaKeluarga === '') {
                                        kepalaKeluarga = detail.nama
                                    }
                                })
                
                                Get("penduduk/kk/"+data.results.id, null, dtkk => {
                                    let frmNik = [];
                                    dtkk.results.forEach(dt => {
                                        frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
                                    });
                                    
                                    setFormData({
                                        ...formData,
                                        nikStat: null, 
                                        dataPemohon: null,
                                        kkStat: e,
                                        detailKK: data.results,
                                        kepalaKeluarga: kepalaKeluarga,
                                        frmNik: frmNik,
                                    })

                                    if (kioskMode) {
                                        props.setLoadingPreview(false)
                                    }
                                    else{
                                        setAlert({
                                            loadingPreview: false
                                        })
                                    }
                                })
                            }
                            else{
                                if (kioskMode) {
                                    props.setLoadingPreview(false)
                                }
                                else{
                                    setAlert({
                                        loadingPreview: false
                                    })
                                }
                                const alertData = {
                                    show: true,
                                    basicType: "warning",
                                    basicTitle: "Data Surat Pindah",
                                    pesanAlert: "Data Penduduk Tidak Lengkap, Silahkan pastikan data penduduk lengkap dan sesuai terlebih dahulu untuk melanjutkan proses pengajuan!"
                                }
                                setAlert(alertData)

                                setFormData({
                                    ...formData,
                                    status: {
                                        ...formData.status,
                                        btnForm: false,
                                        form: false
                                    }
                                });
                                setIsOpen(false);
                            }  
                        }
                        else{
                            if (kioskMode) {
                                props.setLoadingPreview(false)
                            }
                            else{
                                setAlert({
                                    loadingPreview: false
                                })
                            }
                            
                            const alertData = {
                                show: true,
                                basicType: "warning",
                                basicTitle: "Data Kartu Keluarga",
                                pesanAlert: "Data kartu keluarga tidak ditemukan!"
                            }
                            setAlert(alertData)
                        }
                    })

                    break;
                case 'nik': 
                    Get("penduduk/find", e.value, data => {
                        if (data.results) {
                            setFormData({
                                ...formData,
                                nikStat : {
                                    value: e.value,
                                    label: e.value
                                },
                                dataPemohon: {
                                    nik: data.results.id,
                                    nama_pemohon: data.results.nama,
                                    tempat_lahir: data.results.tempat_lahir,
                                    tanggal_lahir: data.results.tanggal_lahir,
                                    pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                                    pekerjaan: data.results.data_pekerjaan.nama,
                                    agama: data.results.data_agama.nama,
                                    status_perkawinan: data.results.status_perkawinan,
                                    alamat: data.results.alamat,
                                    jenis_kelamin: data.results.jk,
                                    kewarganegaraan: "WNI",
                                    tujuan_pembuatan: 'Surat Keterangan Pindah Datang WNI',
                                    kk: data.results.id_kk,
                                },
                            })

                            if (kioskMode) {
                                props.setLoadingPreview(false)
                            }
                            else{
                                setAlert({
                                    loadingPreview: false
                                })
                            }
                        }
                        else{
                            if (kioskMode) {
                                props.setLoadingPreview(false)
                            }
                            else{
                                setAlert({
                                    loadingPreview: false
                                })
                            }
                        }
                    });
                    break;
                case 'nik2': 
                    setFormData({
                        ...formData,
                        nik2Stat: e
                    })
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'shdk_aw': 
                    setFormData({
                        ...formData,
                        shdk_aw: e
                    })
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'alasan_pindah': 
                    if (e.value === '7') {
                        setFormData({
                            ...formData,
                            alasanPindah: e,
                            dtPindah: {
                                ...formData.dtPindah, 
                                alasan_pindah: ''
                            } 
                        })
                    }
                    else{
                        setFormData({
                            ...formData,
                            alasanPindah: e 
                        })
                    }

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'klasifikasi_pindah': 
                    setFormData({
                        ...formData,
                        klasifikasiPindah: e 
                    })
                    
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'jenis_pindah': 
                    setFormData({
                        ...formData,
                        jenisPindah: e,
                    })

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'status_tidak_pindah': 
                    setFormData({
                        ...formData,
                        statusTidakPindah: e,
                    })

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'status_pindah': 
                    setFormData({
                        ...formData,
                        statusPindah: e,
                    })

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                    break;
                case 'provinsi':
                    // setFormData({
                    //     ...formData,
                    //     prvStat: e,
                    //     kbktStat: null,
                    //     kecStat: null,
                    // })
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }

                    return e;

                    break;
                case 'kab-kota':
                    // setFormData({
                    //     ...formData,
                    //     kbktStat: e,
                    //     kecStat: null,
                    // })
                    
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }

                    return e;

                    break;
                case 'kecamatan':
                    // setFormData({
                    //     ...formData,
                    //     kecStat: e,
                    //     kldsStat: null 
                    // })
                    
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }

                    return e;

                    break;
                case 'keldes':
                    // setFormData({
                    //     ...formData,
                    //     kldsStat: e
                    // })
                                   
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }

                    return e;

                    break;
                default:
                // no default
                break;
            }
        } else {
            switch (sel) {
                case 'kk':
                    setDt({
                        ...dt,
                        id_kk: 0,
                    })
                    setFormData({
                        ...formData,
                        kepalaKeluarga: '',
                        kkStat: null, 
                        detailkk: null, 
                        frmNik: [] 
                    })
                    break;
                case 'nik':
                    setFormData({
                        ...formData,
                        nikStat: null, 
                        dataPemohon: null,
                    })
                    break;
                case 'nik2':
                    setFormData({
                        ...formData,
                        nik2Stat: null, 
                    })
                    break;
                case 'shdk_aw':
                    setFormData({
                        ...formData,
                        shdk_aw: null, 
                    })
                    break;
                case 'alasan_pindah':
                    setFormData({
                        ...formData,
                        alasanPindah: null,
                    })
                    break;
                case 'klasifikasi_pindah':
                    setFormData({
                        ...formData,
                        klasifikasiPindah: null,
                    })
                    break;
                case 'jenis_pindah':
                    setFormData({
                        ...formData,
                        jenisPindah: null,
                    })
                    break;
                case 'status_tidak_pindah':
                    setFormData({
                        ...formData,
                        statusTidakPindah: null,
                    })
                    break;
                case 'status_pindah':
                    setFormData({
                        ...formData,
                        statusPindah: null,
                    })
                    break;
                case 'provinsi':
                    setFormData({
                        ...formData,
                        prvStat: null,
                        kbktStat: null, 
                        frmKbkt: [],
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKel: [],
                    })
                    break;
                case 'kab-kota':
                    setFormData({
                        ...formData,
                        kbktStat: null, 
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKel: [],
                    })
                    break;
                case 'kecamatan':
                    setFormData({
                        ...formData,
                        kecStat: null, 
                        kldsStat: null,
                        frmKel: [],
                    })
                    break;
                case 'keldes':
                    setFormData({
                        ...formData,
                        kldsStat: null
                    })
                    break;
                default:
                    // no default
                    break;
            }
        }
    
        // this.setState({
        //   status:{
        //     ...this.state.status,
        //     select: false,
        //   },
        //   loadingPreview: false
        // })
        //     this.forceUpdate();
    };

    const gantiTgl = (date, fld) => {
        switch (fld) {
        case "tgl_pindah":
            if (typeof date._isValid !== 'undefined') {
                let tgl = date.format('YYYY-MM-DD HH:mm:ss');
                setFormData({
                    ...formData,
                    dtPindah: {
                        ...formData.dtPindah, 
                        tgl_pindah: new Date(tgl)
                    } 
                })
            }
            break;
        default:
            // no default
            break;
        }
    };

    const tambahAw = (e) => {
        if (formData.nik2Stat !== null && formData.shdk_aw) {
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            let detail = dt.detail;

            Get("penduduk/find", formData.nik2Stat.value, data => {
                if (data.results) {
                    detail.push({
                        nik: formData.nik2Stat.value,
                        nama: data.results.nama,
                        jenis_kelamin: data.results.jk,
                        tanggal_lahir: data.results.tanggal_lahir,
                        tempat_lahir: data.results.tempat_lahir,
                        pekerjaan: data.results.data_pekerjaan.nama,
                        pendidikan: data.results.data_pendidikan_terakhir.nama,
                        shdk: formData.shdk_aw,
                        keterangan: "",
                    });

                    setFormData({
                        ...formData,
                        nik2Stat: null, 
                        shdk_aw: null, 
                    })
                    setDt({
                        ...dt,
                        detail: detail,
                    })
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
            });
        } else {
            const alertData = {
                show: true,
                basicType: "info",
                basicTitle: "Surat Keterangan Pindah Datang WNI",
                pesanAlert: "Pilih NIK dan hubungan keluarga terlebih dahulu"
            }
            setAlert(alertData)
        }
    };

    const hapusDetail = (i) => {
		
		let newDetail = dt.detail.splice(i, 1)

		setDt({
			...dt,
			detail: dt.detail
		})
	};

  const simpan = e => {
    e.preventDefault();

    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    if (
        formData.kkStat &&
        formData.nikStat &&
        formData.dataPemohon &&
        formData.detailKK &&
        formData.alasanPindah &&
        formData.prvStat &&
        formData.kbktStat &&
        formData.kecStat &&
        formData.kldsStat &&
        formData.klasifikasiPindah &&
        formData.jenisPindah &&
        formData.statusTidakPindah &&
        formData.statusPindah &&
        formData.dtPindah.tgl_pindah
    ) {

        
        // data daerah asal
        let kode_pos = formData.dtAsal.kode_pos
        let telepon = formData.dtAsal.telepon

        // data kepindahan
        let alasan_pindah = '' 
        if (formData.alasanPindah.value === '7') {
            alasan_pindah = {
                value: formData.alasanPindah.value,
                label: formData.dtPindah.alasan_pindah,
            }
        } else {
            alasan_pindah = formData.alasanPindah
        }
        let kode_pos_pindah = formData.dtPindah.kode_pos
        let telepon_pindah = formData.dtPindah.telepon
        let alamat_pindah = formData.dtPindah.alamat
        let rt_pindah = formData.dtPindah.rt
        let rw_pindah = formData.dtPindah.rw

        // Check validation
        if (kode_pos.length > 5 || kode_pos_pindah.length > 5) {
            if (kioskMode){
                props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal', true);
                props.setLoadingPreview(false)
            }
            else{
                setAlert({
                    loadingPreview: false
                })
                const alertData = {
                    show: true,
                    basicType: "warning",
                    basicTitle: "Data Surat Pindah",
                    pesanAlert: 'Jumlah digit kode pos tidak boleh lebih dari 5 angka'
                }
                setAlert(alertData)
            }
        } else if (telepon && telepon.length > 13 || telepon_pindah && telepon_pindah.length > 13) {
            if (kioskMode){
                props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal', true);
                props.setLoadingPreview(false)
            }
            else{
                setAlert({
                    loadingPreview: false
                })
                const alertData = {
                    show: true,
                    basicType: 'warning',
                    basicTitle: 'Data Surat Pindah',
                    pesanAlert: 'Jumlah digit nomor telepon tidak boleh lebih dari 13 angka'
                }
                setAlert(alertData)
            }
        } else if (rt_pindah.length !== 3) {
            if (kioskMode){
                props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal', true);
                props.setLoadingPreview(false)
            }
            else{
                setAlert({
                    loadingPreview: false
                })
                const alertData = {
                    show: true,
                    basicType: 'warning',
                    basicTitle: 'Data Surat Pindah',
                    pesanAlert: 'Jumlah digit kode RT harus 3 angka'
                }
                setAlert(alertData)
            }
        } else if (rw_pindah.length !== 3) {
            if (kioskMode){
                props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal', true);
                props.setLoadingPreview(false)
            }
            else{
                setAlert({
                    loadingPreview: false
                })
                const alertData = {
                    show: true,
                    basicType: 'warning',
                    basicTitle: 'Data Surat Pindah',
                    pesanAlert: 'Jumlah digit kode RW harus 3 angka'
                }
                setAlert(alertData)
            }
        } else {

            let keluarga_yang_pindah = []
    
            dt.detail.forEach((data, index) => {
                keluarga_yang_pindah.push({
                    nik: data.nik,
                    nama: data.nama,
                    shdk: data.shdk,
                    jenis_kelamin: data.jenis_kelamin,
                    tanggal_lahir: data.tanggal_lahir,
                    tempat_lahir: data.tempat_lahir,
                })
            })

            let set_tanggal_pindah = dateFormat(formData.dtPindah.tgl_pindah, 'yyyy-mm-dd');
    
            let detail = {
                data_daerah_asal: {
                    no_kk: formData.detailKK.id,
                    nik_kepala_keluarga: formData.detailKK.nama_kepala_keluarga?formData.detailKK.nama_kepala_keluarga.id:'',
                    nama_kepala_keluarga: formData.kepalaKeluarga,
                    alamat: formData.detailKK.alamat,
                    alamat_kk: formData.detailKK.alamat_kk,
                    rt: formData.detailKK.data_rt.nama,
                    rw: formData.detailKK.data_rt.data_rw.nama,
                    provinsi: formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama,
                    kabkota: formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.nama,
                    kecamatan: formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.nama,
                    deskel: formData.detailKK.data_rt.data_rw.data_keldes.nama,
                    dusun: formData.detailKK.data_rt.data_rw.data_dusun.nama,
                    kode_pos: kode_pos,
                    telp: telepon 
                },
                data_kepindahan: {
                    alasan_pindah: alasan_pindah,
                    alamat: alamat_pindah,
                    rt: rt_pindah,
                    rw: rw_pindah,
                    provinsi: formData.prvStat,
                    kabkota: formData.kbktStat,
                    kecamatan: formData.kecStat,
                    deskel: formData.kldsStat,
                    kode_pos: kode_pos_pindah,
                    telp: telepon_pindah,
                    klasifikasi_pindah: formData.klasifikasiPindah,
                    jenis_pindah: formData.jenisPindah,
                    status_nomor_kk_bagi_tidak_pindah: formData.statusTidakPindah,
                    status_nomor_kk_bagi_pindah: formData.statusPindah,
                    tanggal_pindah: set_tanggal_pindah
                },
                keluarga_yang_pindah: keluarga_yang_pindah
            }

            let bodyRaw = { 
                uuid: dt.uuid,
                id_jenis: dt.id_jenis,
                nik_pelapor: formData.dataPemohon.nik,
                nik: formData.dataPemohon.nik,
                nama_pemohon: formData.dataPemohon.nama_pemohon,
                tempat_lahir: formData.dataPemohon.tempat_lahir,
                tanggal_lahir: formData.dataPemohon.tanggal_lahir,
                pendidikan_terakhir: formData.dataPemohon.pendidikan_terakhir,
                pekerjaan: formData.dataPemohon.pekerjaan,
                agama: formData.dataPemohon.agama,
                status_perkawinan: formData.dataPemohon.status_perkawinan,
                alamat: formData.dataPemohon.alamat,
                jenis_kelamin: formData.dataPemohon.jenis_kelamin,
                kewarganegaraan: 'WNI',
                tujuan_pembuatan: 'Surat Keterangan Pindah Datang WNI',
                kk: formData.dataPemohon.kk,
        
                tanggal_surat: dateFormat(new Date(), 'yyyy-mm-dd'),
        
                detail_surat: JSON.stringify(detail)
            }
            
            if (dt.uuid === "") {
                if (kioskMode) {
                    bodyRaw.id_jenis = props.id_jenis
                } else {
                    bodyRaw.id_jenis = props.location.state.uuid
                }
            }

            let psn = "";
            let resstat = 204;
            let metode = "create";
            if (bodyRaw.uuid === "") {
                psn = "Tambah";
                resstat = 201;
                bodyRaw.uuid = null;
            } else {
                psn = "Ubah";
                resstat = 200;
                metode = "update";
            }
        
            Post(
                "surat-keterangan/grup/" + metode,
                bodyRaw.uuid,
                bodyRaw,
                res => {
                // For testing
                if (props.resSubmit) {
                    props.resSubmit(res.status);
                }
                
                setFormData({
                    ...formData,
                    status: {
                        ...formData.status,
                        btnForm: false,
                        form: false
                    }
                });
                setIsOpen(false);

                if (kioskMode) {
                    if (res.status === resstat) {
                        let dataAntrian = {
                            nama: props.data.results.nama,
                            nik: props.data.results.id,
                            keterangan: '',
                            uuid_surat:res.data.results.uuid_surat,
                            kode_surat:res.data.results.kode_surat,
                        };
    
                        // Set Data Surat
                        props.getDataSurat(res.data.results);
    
                        setTimeout(function () {
                            Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
                                
                                props.setLoadingPreview(false)
                                
                                if (res2.code === 201) {
                                    props.getAntrian('Surat Keterangan Pindah Datang WNI', 'berhasil', false, dataAntrian);
                                }
                                else {
                                    props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal');
                                }
                            });
                        }.bind(this),1000)
                    }
                    else{
                        props.setLoadingPreview(false)
                        props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal');
                    }
                } else {
                    if (res.status === resstat) {
                        const alertData = {
                            get_data_surat:{
                                uuid_surat:res.data.results.uuid_surat,
                                kode_surat:res.data.results.kode_surat,
                            },
                            status:{
                                frmPreviewDraft: true,
                                jenis_form: psn,
                            }
                            // show: true,
                            // basicType: "success",
                            // basicTitle: "Data Surat Keterangan Pindah Datang WNI",
                            // pesanAlert: "Berhasil " + psn + " Data",
                            // successAlert: true
                        };
                        setAlert({
                            loadingPreview: false
                        })
                        setAlert(alertData);
                    } else {
                        const alertData = {
                            show: true,
                            basicType: "danger",
                            basicTitle: "Data Surat Keterangan Pindah Datang WNI",
                            pesanAlert: "Gagal " + psn + " Data"
                        };
                        setAlert({
                            loadingPreview: false
                        })
                        setAlert(alertData);
                    }
                    // Refresh list
                    setStatusRefresh(true);
                }
            });
    
        }
    } else {
        if (kioskMode){
			props.getAntrian('Surat Keterangan Pindah Datang WNI', 'gagal', true);
            props.setLoadingPreview(false)
        }
        else{
            const alertData = {
                show: true,
                basicType: "info",
                basicTitle: "Data Belum Lengkap",
                pesanAlert: "Mohon isi seluruh data dengan benar"
            }
            setAlert({
                loadingPreview: false
            })
            setAlert(alertData)
        }
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      style={{
        maxwidth: "unset"
      }}
      styles={{
      	// modal: {
      		width: '100%',
      		// minWidth: '301px'
      	// }
      }}
    >
      <Form data-testid="form-create" className="theme-form" onSubmit={simpan}>
        <div className="modal-header">
          <h5 className="modal-title">
            {dt.uuid == "" ? "Tambah" : "Edit"} Surat Keterangan Pindah Datang WNI
          </h5>
        </div>
        <div className="modal-body">
            <p>
                Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
                ada ketidak sesuaian data, silakan ubah di data master penduduk.
            </p>
            <input
                className="form-control"
                id="uuid"
                type="hidden"
                placeholder=""
                defaultValue={dt.uuid}
            />
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                <b>Data Daerah Asal</b>
            </div>
            <FormGroup className="row">
                <Label className="col-sm-4 col-form-label" htmlFor="nik">
                    Nomor KK Pemohon
                </Label>
                <Col sm="8">
                    <div data-testid="selectKK">
                        <Select
                            inputId="kk"
                            id="noKKPenduduk"
                            // isDisabled={this.state.status.select}
                            classNamePrefix="select"
                            onChange={(e) => {
                                changeSelectValue(e, 'kk');
                            }}
                            defaultValue={formData.kkStat}
                            value={formData.kkStat}
                            name="No KK"
                            options={formData.frmKk}
                            placeholder="Pilih KK"
                            onInputChange={(e) => handleInputChangeNIK(e, 'kk')}
                            isClearable
                        />
                    </div>
                </Col>
            </FormGroup>
            {formData.detailKK && formData.kepalaKeluarga !== '' ? (
                <>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" >
                            NIK Kepala Keluarga
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                value={formData.detailKK.nama_kepala_keluarga?formData.detailKK.nama_kepala_keluarga.id:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" >
                            Nama Kepala Keluarga
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            className="form-control"
                            style={{
                                marginBottom: '10px',
                                fontWeight: 400,
                                fontSize: 'inherit',
                                backgroundColor: '#c9d1d8'
                            }}
                            value={formData.kepalaKeluarga}
                            required
                            type="text"
                            disabled
                            readOnly
                        />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" >
                            Alamat
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            className="form-control"
                            style={{
                                marginBottom: '10px',
                                fontWeight: 400,
                                fontSize: 'inherit',
                                backgroundColor: '#c9d1d8'
                            }}
                            value={formData.detailKK.alamat}
                            required
                            type="text"
                            disabled
                            readOnly
                        />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            RT
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt?this.state.detailKK.data_rt.nama:''}
                                value={formData.detailKK.data_rt?formData.detailKK.data_rt.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            RW
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt && this.state.detailKK.data_rt.data_rw?this.state.detailKK.data_rt.data_rw.nama:''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw?formData.detailKK.data_rt.data_rw.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            {localStorage.getItem('JENIS_DUSUN')}
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt && this.state.detailKK.data_rt.data_rw && this.state.detailKK.data_rt.data_rw.data_dusun? this.state.detailKK.data_rt.data_rw.data_dusun.nama:''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_dusun? formData.detailKK.data_rt.data_rw.data_dusun.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            {JENIS_DESA} / Kelurahan
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt && this.state.detailKK.data_rt.data_rw && this.state.detailKK.data_rt.data_rw.data_keldes?this.state.detailKK.data_rt.data_rw.data_keldes.nama:''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_keldes?formData.detailKK.data_rt.data_rw.data_keldes.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            Kecamatan
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt && this.state.detailKK.data_rt.data_rw && this.state.detailKK.data_rt.data_rw.data_keldes && this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan?this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.nama:''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_keldes && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan?formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            Kab/Kota
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_keldes && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota?formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.nama:''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_keldes && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota?formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.nama:''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            Provinsi
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit',
                                    backgroundColor: '#c9d1d8'
                                }}
                                // defaultValue={this.state.detailKK.data_rt && this.state.detailKK.data_rt.data_rw && this.state.detailKK.data_rt.data_rw.data_keldes && this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan && this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota && this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.data_provinsi?this.state.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama : ''}
                                value={formData.detailKK.data_rt && formData.detailKK.data_rt.data_rw && formData.detailKK.data_rt.data_rw.data_keldes && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota && formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.data_provinsi?formData.detailKK.data_rt.data_rw.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama : ''}
                                required
                                type="text"
                                disabled
                                readOnly
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            Kode Pos
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                data-testid="kode_pos"
                                name="kode_pos"
                                id="kode_pos"
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit'
                                }}
                                defaultValue={formData.dtAsal.kode_pos}
                                required
                                type="text"
                                pattern="\d{1,16}"
                                maxLength={5}
                                placeholder="Masukkan kode pos (Contoh : 28285)"
                                onChange={e => changeInputText(e,'formdata', "dtAsal","kode_pos")}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup className="row" style={{ marginBottom: '0px' }}>
                        <Label className="col-sm-4 col-form-label" style={{  paddingLeft: 35 }}>
                            Telepon
                        </Label>
                        <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                data-testid="telepon"
                                name="telepon"
                                id="telepon"
                                className="form-control"
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    fontSize: 'inherit'
                                }}
                                defaultValue={formData.dtAsal.telepon}
                                // required
                                type="text"
                                pattern="\d{1,16}"
                                maxLength={13}
                                placeholder="Masukkan nomor telepon rumah jika ada (Contoh : 0761252532)"
                                onChange={e => changeInputText(e,'formdata', "dtAsal","telepon")}
                            />
                        </div>
                    </FormGroup>
                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Data Pemohon</b>
                    </div>
                    <FormGroup className="row" style={{ marginBottom: '10px' }}>
                        <Label className="col-sm-4 col-form-label" >
                            NIK Pemohon
                        </Label>
                        <div className="col-sm-8" data-testid="selectNIK">
                            <Select
                                inputId="nik"
                                classNamePrefix="select"
                                onChange={e => {
                                    getPenduduk(e, "nik", "pemohon");
                                }}
                                defaultValue={formData.nikStat}
                                value={formData.nikStat}
                                name="NIK"
                                options={formData.frmNik}
                                placeholder="Pilih NIK Pemohon"
                                isClearable
                            />
                        </div>
                    </FormGroup>
                    {formData.dataPemohon ? (
                        <>
                            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                                <Label className="col-sm-4 col-form-label" >
                                    Nama Pemohon
                                </Label>
                                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        className="form-control"
                                        style={{
                                        marginBottom: '10px',
                                        fontWeight: 400,
                                        fontSize: 'inherit',
                                        backgroundColor: '#c9d1d8'
                                        }}
                                        // defaultValue={this.state.dataPemohon.nama_pemohon}
                                        value={formData.dataPemohon.nama_pemohon}
                                        required
                                        type="text"
                                        disabled
                                        readOnly
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                                <Label className="col-sm-4 col-form-label" >
                                    NIK Pemohon
                                </Label>
                                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        className="form-control"
                                        style={{
                                        marginBottom: '10px',
                                        fontWeight: 400,
                                        fontSize: 'inherit',
                                        backgroundColor: '#c9d1d8'
                                        }}
                                        // defaultValue={this.state.dataPemohon.nik}
                                        value={formData.dataPemohon.nik}
                                        required
                                        type="text"
                                        disabled
                                        readOnly
                                    />
                                </div>
                            </FormGroup>
                        </>
                    ) : ''}
                </>
            ) : ''}

            {/* Data Kepindahan */}
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                <b>Data Kepindahan</b>
            </div>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                Alasan Pindah
                </Label>
                <div className="col-sm-8" data-testid="selectAlasanPindah">
                    <Select
                        inputId="alasan_pindah"
                        // isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={(e) => {
                            changeSelectValue(e, 'alasan_pindah');
                        }}
                        defaultValue={formData.alasanPindah}
                        value={formData.alasanPindah}
                        name="Alasan Pindah"
                        options={[
                            {value: '1', label: 'Pekerjaan'},
                            {value: '2', label: 'Pendidikan'},
                            {value: '3', label: 'Keamanan'},
                            {value: '4', label: 'Kesehatan'},
                            {value: '5', label: 'Perumahan'},
                            {value: '6', label: 'Keluarga'},
                            {value: '7', label: 'Lainnya'},
                        ]}
                        placeholder="Pilih Alasan Pindah"
                        isClearable
                    />
                </div>
            </FormGroup>
            {formData.alasanPindah && formData.alasanPindah.label === 'Lainnya' ? (
                <FormGroup className="row" style={{ marginBottom: '0px', marginTop: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Keterangan Alasan Pindah
                </Label>
                <div className="col-sm-8">
                    <input
                        data-testid="keterangan_alasan_pindah"
                        name="keterangan_alasan_pindah"
                        id="alasan_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '10px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.alasan_pindah}
                        required
                        type="text"
                        placeholder="Ketikkan alasan pindah (Contoh : Pindah Tugas)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","alasan_pindah")}
                    />
                </div>
                </FormGroup>
            ) : ''}
            <FormGroup className="row" style={{ marginBottom: '0px', marginTop: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Alamat
                </Label>
                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        data-testid="alamat_pindah"
                        name="alamat_pindah"
                        id="alamat_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '10px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.alamat}
                        required
                        type="text"
                        placeholder="Masukkan alamat pindah (Contoh : Jl. Sudirman No. 17A)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","alamat")}
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    RT
                </Label>
                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        data-testid="rt_pindah"
                        name="rt_pindah"
                        id="rt_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '10px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.rt}
                        required
                        type="text"
                        pattern="\d{1,16}"
                        maxLength={3}
                        placeholder="Masukkan RT (Contoh : 002)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","rt")}
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    RW
                </Label>
                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        data-testid="rw_pindah"
                        name="rw_pindah"
                        id="rw_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '10px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.rw}
                        required
                        type="text"
                        pattern="\d{1,16}"
                        maxLength={3}
                        placeholder="Masukkan RW (Contoh : 007)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","rw")}
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    Provinsi
                </Label>
                <div className="col-sm-8" data-testid="selectProv">
                    <Select
                        inputId="provinsi"
                        // isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={(e) => {
                            getChild(e, 'provinsi', 'prov', 'kab-kota');
                        }}
                        defaultValue={formData.prvStat}
                        value={formData.prvStat}
                        name="provinsi"
                        options={formData.frmPrv}
                        placeholder="Pilih Provinsi"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    Kab/Kota
                </Label>
                <div className="col-sm-8" data-testid="selectKab">
                    <Select
                        inputId="kabupaten"
                        // isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={(e) => {
                            getChild(e, 'kab-kota', 'kab', 'kecamatan');
                        }}
                        defaultValue={formData.kbktStat}
                        value={formData.kbktStat}
                        name="kabkota"
                        options={formData.frmKbkt}
                        placeholder="Pilih Kabupaten/Kota"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    Kecamatan
                </Label>
                <div className="col-sm-8" data-testid="selectKec">
                    <Select
                        inputId="kecamatan"
                        // isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={(e) => {
                            getChild(e, 'kecamatan', 'kec', 'keldes');
                        }}
                        defaultValue={formData.kecStat}
                        value={formData.kecStat}
                        name="kecamatan"
                        options={formData.frmKec}
                        placeholder="Pilih Kecamatan"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    
                        {localStorage.getItem('JENIS_DESA').toLowerCase() === 'kelurahan' ? (
                        'Kelurahan'
                        ) : (
                        'Kelurahan / ' + localStorage.getItem('JENIS_DESA')
                        )}
                    
                </Label>
                <div className="col-sm-8" data-testid="selectKeldes">
                    <Select
                        inputId="keldes"
                        // isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={(e) => {
                            if (formData.isKelurahan) {
                                getChild(e, 'keldes', 'kel', 'rw');
                            } else {
                                getChild(e, 'keldes', 'kel', 'dusun');
                            }
                        }}
                        defaultValue={formData.kldsStat}
                        value={formData.kldsStat}
                        name="keldes"
                        options={formData.frmKel}
                        placeholder={
                            JENIS_DESA.toLowerCase() === 'kelurahan' ? (
                                'Pilih Kelurahan'
                            ) : (
                                'Pilih Kelurahan / ' + JENIS_DESA
                            )
                        }
                        isClearable
                        required
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    Kode Pos
                </Label>
                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        data-testid="kode_pos_pindah"
                        name="kode_pos_pindah"
                        id="kode_pos_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '10px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.kode_pos}
                        required
                        type="text"
                        pattern="\d{1,16}"
                        maxLength={5}
                        placeholder="Masukkan kode pos (Contoh : 28285)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","kode_pos")}
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{ paddingLeft: 35 }}>
                    Telepon
                </Label>
                <div className="col-sm-8" style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        data-testid="telepon_pindah"
                        name="telepon_pindah"
                        id="telepon_pindah"
                        className="form-control"
                        style={{
                            marginBottom: '0px',
                            fontWeight: 400,
                            fontSize: 'inherit'
                        }}
                        defaultValue={formData.dtPindah.telepon}
                        // required
                        type="text"
                        pattern="\d{1,16}"
                        maxLength={13}
                        placeholder="Masukkan nomor telepon rumah jika ada (Contoh : 0761252532)"
                        onChange={e => changeInputText(e,'formdata', "dtPindah","telepon")}
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Klasifikasi Pindah
                </Label>
                <div className="col-sm-8" data-testid="selectKlasifikasiPindah">
                    <Select
                        inputId="klasifikasi_pindah"
                        classNamePrefix="select"
                        onChange={(e) => {
                            changeSelectValue(e, 'klasifikasi_pindah');
                        }}
                        defaultValue={formData.klasifikasiPindah}
                        value={formData.klasifikasiPindah}
                        name="Klasifikasi Pindah"
                        options={[
                            {value: '1', label: 'Dalam satu ' + JENIS_DESA + ' / Kelurahan'},
                            {value: '2', label: 'Antar ' + JENIS_DESA + ' / Kelurahan'},
                            {value: '3', label: 'Antar Kecamatan'},
                            {value: '4', label: 'Antar Kab/Kota'},
                            {value: '5', label: 'Antar Provinsi'},
                        ]}
                        placeholder="Pilih Klasifikasi Pindah"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Jenis Kepindahan
                </Label>
                <div className="col-sm-8" data-testid="selectJenisPindah">
                    <Select
                        inputId="jenis_pindah"
                        classNamePrefix="select"
                        onChange={(e) => {
                            changeSelectValue(e, 'jenis_pindah');
                        }}
                        defaultValue={formData.jenisPindah}
                        value={formData.jenisPindah}
                        name="Jenis Kepindahan"
                        options={[
                            {value: '1', label: 'Kep. Keluarga'},
                            {value: '2', label: 'Kep. Keluarga dan Seluruh Anggota Keluarga'},
                            {value: '3', label: 'Kep. Keluarga dan Sbg. Angg. keluarga'},
                            {value: '4', label: 'Angg. Keluarga'},
                        ]}
                        placeholder="Pilih Jenis Kepindahan"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Status Nomor KK Bagi Yang Tidak Pindah
                </Label>
                <div className="col-sm-8" data-testid="selectStatusTidakPindah">
                    <Select
                        inputId="status_tidak_pindah"
                        classNamePrefix="select"
                        onChange={(e) => {
                            changeSelectValue(e, 'status_tidak_pindah');
                        }}
                        defaultValue={formData.statusTidakPindah}
                        value={formData.statusTidakPindah}
                        name="Status Tidak Pindah"
                        options={[
                            {value: '1', label: 'Numpang KK'},
                            {value: '2', label: 'Membuat KK Baru'},
                            {value: '3', label: 'Tidak Ada Angg. Keluarga Yang Ditinggal'},
                            {value: '4', label: 'Nomor KK Tetap'},
                        ]}
                        placeholder="Pilih Status Nomor KK yang Tidak Pindah"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Status Nomor KK Bagi Yang Pindah
                </Label>
                <div className="col-sm-8" data-testid="selectStatusPindah">
                    <Select
                        inputId="status_pindah"
                        classNamePrefix="select"
                        onChange={(e) => {
                            changeSelectValue(e, 'status_pindah');
                        }}
                        defaultValue={formData.statusPindah}
                        value={formData.statusPindah}
                        name="Status Tidak Pindah"
                        options={[
                            {value: '1', label: 'Numpang KK'},
                            {value: '2', label: 'Membuat KK Baru'},
                            {value: '3', label: 'Nama Kep. Keluarga dan Nomor KK Tetap'},
                        ]}
                        placeholder="Pilih Status Nomor KK yang Pindah"
                        isClearable
                    />
                </div>
            </FormGroup>
            <FormGroup className="row" style={{ marginBottom: '10px' }}>
                <Label className="col-sm-4 col-form-label" style={{  }}>
                    Rencana Tanggal Pindah
                </Label>
                <div className="col-sm-8">
                    <Datetime
                        inputProps={{ "data-testid": "tgl_pindah", placeholder: 'Tanggal Pindah' }}
                        data-testid="tgl_pindah"
                        inputId="tgl_pindah"
                        name="tgl_pindah"
                        id="tgl_pindah"
                        locale="id-ID"
                        dateFormat="DD/MM/yyyy"
                        timeFormat={false}
                        input={true}
                        closeOnTab={true}
                        closeOnSelect={true}
                        value={formData.dtPindah.tgl_pindah}
                        initialValue={formData.dtPindah.tgl_pindah}
                        onChange={e => {
                            gantiTgl(e,'tgl_pindah')
                        }}
                    />
                </div>
            </FormGroup>

            {formData.kkStat ? 
                <>
                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Daftar Keluarga Yang Ikut</b>
                    </div>
                    <FormGroup className="row">
                        <Col sm="6">
                            <label>NIK Anggota Keluarga</label>
                            <div data-testid="selectNIK2">
                                <Select
                                    inputId="nik2"
                                    classNamePrefix="select"
                                    onChange={e => {
                                        changeSelectValue(e, "nik2");
                                    }}
                                    defaultValue={formData.nik2Stat}
                                    value={formData.nik2Stat}
                                    name="NIK2"
                                    options={formData.frmNik}
                                    placeholder="Pilih NIK Anggota Keluarga yang Ikut"
                                    isClearable
                                />
                            </div>
                        </Col>
                        <Col sm="6">
                            <label>Hubungan Keluarga</label>
                            <div data-testid="selectShdk">
                                <Select
                                    inputId="shdk_aw"
                                    classNamePrefix="select"
                                    onChange={(e) => {
                                        changeSelectValue(e, 'shdk_aw');
                                    }}
                                    value={formData.shdk_aw}
                                    id="shdk"
                                    options={[
                                        { value: '01', label: 'Kep. Keluarga' },
                                        { value: '02', label: 'Suami' },
                                        { value: '03', label: 'Isteri' },
                                        { value: '04', label: 'Anak' },
                                        { value: '05', label: 'Menantu' },
                                        { value: '06', label: 'Cucu' },
                                        { value: '07', label: 'Orang Tua' },
                                        { value: '08', label: 'Mertua' },
                                        { value: '09', label: 'Famili Lain' },
                                        { value: '10', label: 'Lainnya' },
                                    ]}
                                    placeholder="Hubungan Keluarga"
                                />
                            </div>
                        </Col>
                        <Col sm="12" className="text-right">
                        <br/>
                            <button
                                data-testid="btnTambahKeluarga"
                                type="button"
                                className="btn btn-primary-custom"
                                onClick={(e) => {
                                    tambahAw(e);
                                }}
                            >
                            Tambah
                            </button>
                        </Col>
                        <Col sm="12">
                            {dt.detail.length > 0 ? (
								<Col sm="12">
									<table className="table table-bordered table-stripes table-hovered">
										<thead>
											<tr>
												<th>No</th>
												<th>NIK</th>
												<th>Nama</th>
												<th>L/P</th>
												<th>Tempat/Tanggal Lahir</th>
												<th>Hubungan Keluarga</th>
												<th>
													<i className="fa fa-trash"></i>
												</th>
											</tr>
										</thead>
										<tbody>
											{dt.detail.map((val, i) => {
												let jk = "L";
												if (val.jenis_kelamin === "Perempuan") {
													jk = "P";
												}
												let tgl_lahir = val.tempat_lahir ? val.tempat_lahir + ', ' + Tanggal(val.tanggal_lahir) : ''
												return (
													<tr key={i}>
														<td>{i + 1}</td>
														<td>{val.nik}</td>
														<td>{val.nama}</td>
														<td>{jk}</td>
														<td>
															{tgl_lahir}
														</td>
														<td>{typeof val.shdk == 'object' ? val.shdk.label : val.shdk}</td>
														<td>
															<Button
																size="xs"
																onClick={() => hapusDetail(i)}
																color="danger"
																className="btn-icon"
															>
																<i className="fa fa-trash"></i>
															</Button>
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</Col>
							) : ''}
                        </Col>
                    </FormGroup>
                </>
            : ''}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              // Tutup modal
                setFormData({
                    ...formData,
                    status: {
                        ...formData.status,
                        form: false,
                        frmPreviewDraft: false,
                        jenis_form: '',
                    }
                });
                setIsOpen(false);
            }}
          >
            Tutup
          </button>
          <button
            data-testid="btnSubmitCreate"
            type="submit"
            className="btn btn-primary-custom"
            // disabled={formData.status.btnForm}
          >
            Simpan
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratPindahWNI;
